import { createContext, Component } from "react";
import { decryptData } from "../utils/encryption";
import menuList from "../data/sessionmaster.json";

export const AuthContext = createContext();

class AuthContextProvider extends Component {
  constructor() {
    super();

    const user = JSON.parse(sessionStorage.getItem("UserData"));
    let menuNames = []; 
    if (user?.userId) {
      let accessibleMenus = user.accessibleMenu || []; // array of strings
      accessibleMenus.forEach((sessionName) => {
        if (!menuNames.includes(sessionName)) {
          menuNames.push(sessionName);
        }
        let parentmenu = menuList.find((item) => item.SubMenu === sessionName || item.ParentMenu === sessionName)?.ParentMenu;
        if (parentmenu && !menuNames.includes(parentmenu)) {
          menuNames.push(parentmenu);
        }
      });

      // Decrypt sensitive data when accessing from session storage
      const decryptedUserEmail = user.UserEmail ? decryptData(user.UserEmail) : user.UserEmail;
      const decryptedUserId = user.userId ? decryptData(user.userId) : user.userId;
      const decryptedMobileNo = user.mobileNo ? decryptData(user.mobileNo) : user.mobileNo;
      const decryptedAltMobileNo = user.altmobileNo ? decryptData(user.altmobileNo) : user.altmobileNo;

      this.state = {
        userName: user.UserName,
        userEmail: decryptedUserEmail,
        role: user.UserRoleCode,
        accessibleMenus: accessibleMenus,
        menuName: menuNames,
        userType: user.usertype,
        dataControl: user.dataControl,
        userId: decryptedUserId,
        division: user.division,
        location: user.location,
        mobileNo: decryptedMobileNo,
        altmobileNo: decryptedAltMobileNo,
      };
    }
  }

  render() {
    return (
      <AuthContext.Provider value={{ ...this.state }}>
        {this.props.children}
      </AuthContext.Provider>
    );
  }
}

export default AuthContextProvider;
